import React from 'react';

const Loading = () => {
    return (
        <div>
            <progress className="progress progress-primary w-full"></progress>
        </div>
    );
};

export default Loading;